<template>
  <main class="page" ref="page">
    <section class="section page__header" >
      <div class="page__row page__row_between">
        <router-link :to="`/task/list/${currentUser.id}`" class="back">
          <span class="back__icon">
            <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 5.5H2M2 5.5L6.14815 1M2 5.5L6.14815 10" stroke="currentColor" stroke-width="1.5"/>
            </svg>
          </span>
          <span class="back__text">
            Список задач
          </span>
        </router-link>
        <div class="page__item" v-if="roleAccessControls">
          <div class="page__row">
            <div class="page__item mr-40" v-if="roleAccessUpdate">
              <AppButtonSmEdit title="Редактировать" @click.native="showUpdateModal"/>
            </div>
            <div class="page__item" v-if="roleAccessRemove">
              <AppButtonSmRemove title="Удалить" @click.native="showRemoveConfirmation"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section page__content task__content" v-if="task.id !== undefined">
      <div class="mobile-title-wrap">
        <div class="task-id">
          Задача №{{ task.id }}
        </div>
        <div class="title">{{ task.name }}</div>
      </div>
      <div class="task">
        <div class="info">
          <div class="important-label mobile-visible" v-if="task.is_important">
            <div class="important-label__text">Важная задача</div>
            <div class="important-label__icon">
              <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.8909 6.5121C11.3899 1.16935 4.05407 0 4.05407 0C4.05407 0 7.43905 4.45161 3.11324 7.97177C0.3778 10.1935 -0.703653 13.0806 0.4682 16.2339C1.3655 18.6492 3.2639 19.6331 5.30962 20C4.33196 17.7782 5.08865 15.0645 5.17235 14.7742C7.08414 18.2581 10.6968 14.7742 8.8821 10.9879C11.2593 11.6089 11.6142 16.5766 9.78945 19.6774C12.4847 18.6573 14.2793 16.0927 14.7715 13.8065C15.2905 11.4153 14.8954 8.64919 13.8909 6.5121Z" fill="currentColor"/>
              </svg>
            </div>
          </div>
          <div class="status ready">
            <b>Статус:&nbsp;</b><span class="status__name">{{ task.column.name }}</span>
          </div>
          <div class="info__block">
            <div class="page__row">
              <div class="data">Создано:</div>
              <div class="value">{{ formatDateTime(task.created_at) }}</div>
            </div>
            <div class="page__row">
              <div class="data">Крайний срок:</div>
              <div class="value">{{ formatDateTime(task.before_at) }}</div>
            </div>
            <div class="page__row stage">
              <div class="data">Стадия:</div>
              <div class="stage__progress">
                <div class="stage__bar-wrap" v-for="column in columnList" :key="column.id" @click.stop="setTaskColumn(column.id)">
                  <span class="stage__bar" :class="column.id <= task.column_id ? column.color : ''" :title="column.name"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="info__block">
            <div class="page__column mb-20">
              <div class="users-data">Постановщик:</div>
              <router-link :to="`/user/info/${task.owner_id}/personal`" class="user-item">
                <div class="user-avatar user-item__avatar">
                  <img v-if="task.owner.avatar !== null && task.owner.avatar.file_size"
                       :src="task.owner.avatar.url" :alt="task.owner.profile.name" :title="task.owner.profile.name">
                  <img v-else src="/img/avatar-thumb.png" :alt="task.owner.profile.name" :title="task.owner.profile.name">
                </div>
                <div class="user-item__name link">{{ task.owner.profile.surname ? task.owner.profile.surname : '' }} {{ task.owner.profile.name }}</div>
              </router-link>
            </div>
            <div class="page__column mb-20">
              <div class="users-data">Ответственные:</div>
              <div v-if="task.assignees && task.assignees.length !== 0">
                <router-link :to="`/user/info/${user.id}/personal`" class="user-item" v-for="user in task.assignees" :key="user.id">
                  <div class="user-avatar user-item__avatar">
                    <img v-if="user.avatar !== null && user.avatar.file_size"
                         :src="user.avatar.url" :alt="user.profile.surname" :title="user.profile.surname">
                    <img v-else src="/img/avatar-thumb.png" :alt="user.profile.surname" :title="user.profile.surname">
                  </div>
                  <div class="user-item__name link">{{ `${user.profile.surname ? user.profile.surname : '' } ${user.profile.name}` }}</div>
                </router-link>
              </div>
              <div v-else>Не назначены</div>
            </div>
            <div class="page__column">
              <div class="users-data">Наблюдатели:</div>
              <div v-if="task.watchers && task.watchers.length !== 0">
                <router-link :to="`/user/info/${user.id}/personal`" class="user-item" v-for="user in task.watchers" :key="user.id">
                  <div class="user-avatar user-item__avatar">
                    <img v-if="user.avatar !== null && user.avatar.file_size"
                         :src="user.avatar.url" :alt="user.profile.surname" :title="user.profile.name">
                    <img v-else src="/img/avatar-thumb.png" :alt="user.profile.surname" :title="user.profile.surname">
                  </div>
                  <div class="user-item__name link">{{ `${user.profile.surname ? user.profile.surname : '' } ${user.profile.name}` }}</div>
                </router-link>
              </div>
              <div v-else>Не назначены</div>
            </div>
          </div>
          <div class="info__block row-wrap" v-if="task.tags && task.tags.length !== 0">
            <div class="data tag-title">Теги:</div>
            <div class="task-attachment" v-for="(tag, i) in task.tags" :key="i">
              <span class="task-attachment__tag-icon">#</span>
              <span class="task-attachment__tag">{{ tag }}</span>
            </div>
          </div>
          <div class="info__block button-wrap">
            <div class="button">
              <AppButton title="Начать"
                         type="third"
                         has-play-icon
                         @click.stop.native="startTask"
              />
            </div>
            <div class="button">
              <AppButton title="Завершить"
                         type="fourth"
                         @click.stop.native="closeTask"
              />
            </div>
          </div>
        </div>

        <div class="description">
          <div class="page__row">
            <div class="title desktop-visible">{{ task.name }}</div>
            <div class="important-label desktop-visible" v-if="task.is_important">
              <div class="important-label__text">Важная задача</div>
              <div class="important-label__icon">
                <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.8909 6.5121C11.3899 1.16935 4.05407 0 4.05407 0C4.05407 0 7.43905 4.45161 3.11324 7.97177C0.3778 10.1935 -0.703653 13.0806 0.4682 16.2339C1.3655 18.6492 3.2639 19.6331 5.30962 20C4.33196 17.7782 5.08865 15.0645 5.17235 14.7742C7.08414 18.2581 10.6968 14.7742 8.8821 10.9879C11.2593 11.6089 11.6142 16.5766 9.78945 19.6774C12.4847 18.6573 14.2793 16.0927 14.7715 13.8065C15.2905 11.4153 14.8954 8.64919 13.8909 6.5121Z" fill="currentColor"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="page__row desktop-visible">
            <div class="task-id">
              Задача №{{ task.id }}
            </div>
          </div>
          <div class="page__row text" v-if="task.description" @click.stop>
            <span class="plain-html" v-html="task.description"></span>
          </div>
          <div class="task-attachment-preview" v-if="task.files && task.files.length !== 0">
            <a :href="file.url" target="_blank" class="task-attachment" v-for="(file, i) in task.files" :key="i" @click.stop>
            <span class="task-attachment__icon">
              <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="mimeTypes.indexOf(file.content_type) + 1">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H17V18H0V0ZM10.5778 6.14099L10.9319 6.74805L14.4319 12.748L14.8705 13.5H14H3H2.02841L2.59314 12.7094L5.09314 9.20935L5.34146 8.86169L5.7236 9.0528L7.37442 9.87817L10.1204 6.67462L10.5778 6.14099ZM10.4222 7.85901L7.87964 10.8254L7.62558 11.1218L7.2764 10.9472L5.65854 10.1383L3.97159 12.5H13.1295L10.4222 7.85901ZM5 7C5.55228 7 6 6.55231 6 6C6 5.44769 5.55228 5 5 5C4.44772 5 4 5.44769 4 6C4 6.55231 4.44772 7 5 7Z" fill="currentColor"/>
              </svg>
              <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 0V5V5.5H12H17V18H0V0H11.5ZM12.5 0.5V4.5H16.5L12.5 0.5Z" fill="currentColor"/>
              </svg>
            </span>
              <span class="task-attachment__name">{{ file.file_name.length > 30 ? `${file.file_name.slice(0, 30)}...` : file.file_name }}</span>
              <span class="task-attachment__size">{{ Math.round(file.file_size/1000) }} кб</span>
            </a>
          </div>
          <div class="page__row">
            <div class="parent-task" v-if="task.parent_id !== 0 && task.parent_id !== null">
              <b>Базовая задача:</b>
              <router-link :to="`/task/info/${task.parent_id}`" class="parent-task__link link">{{ task.parent.name }}</router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="page__column children-tasks" v-if="task.children && task.children.length !== 0">
        <b class="children-tasks__title">Подзадачи</b>
        <TaskChildrenList :children="task.children" />
      </div>
      <ThePageComments :comments="task.comments"
                       :message-area="taskMessageArea"
                       @set-message-value="setCommentMessageValue"
                       @toggle-message-controls="toggleCommentMessageControls"
                       @reply-message="replyCommentMessage"
                       @un-reply-message="unReplyCommentMessage"
                       @update-message="updateCommentMessage"
                       @remove-message="removeCommentMessage"
                       @send-message="sendCommentMessage"
                       @cancel-message-update="cancelCommentMessageUpdate"
                       @attach-files="attachCommentFiles"
                       @remove-file="removeCommentFile"
                       @toggle-link-tooltip="toggleCommentLinkTooltip"
                       @close-link-tooltip="closeCommentLinkTooltip"
                       @selection-range="setCommentInputSelectionRange"
                       @set-link-url="setCommentLinkUrl"
                       @attach-link="attachCommentLink"
                       @toggle-tag-tooltip="toggleCommentTagTooltip"
                       @close-tag-tooltip="closeCommentTagTooltip"
                       @set-tag-text="setCommentTagText"
                       @attach-tag="attachCommentTag"
                       @remove-tag="removeCommentTag"
                       @clear-validation="clearCommentValidation"
      />
    </section>
    <transition name="fade">
      <TaskModal v-if="updateModal.active"
                 type="update"
                 :state="updateModal"
                 @close-modal="closeUpdateModal"
                 @set-name="setUpdatedTaskName"
                 @toggle-importance="toggleUpdatedTaskImportance"
                 @set-description="setUpdatedTaskDescription"
                 @toggle-link-tooltip="toggleUpdatedTaskLinkTooltip"
                 @close-link-tooltip="closeUpdatedTaskLinkTooltip"
                 @selection-range="setModalInputSelectionRange"
                 @set-link-url="setUpdatedTaskLinkUrl"
                 @toggle-tag-tooltip="toggleUpdatedTaskTagTooltip"
                 @close-tag-tooltip="closeUpdatedTaskTagTooltip"
                 @set-tag-text="setUpdatedTaskTagText"
                 @attach-files="attachUpdatedTaskFiles"
                 @remove-file="removeUpdatedTaskFile"
                 @attach-link="attachUpdatedTaskLink"
                 @attach-tag="attachUpdatedTaskTag"
                 @remove-tag="removeUpdatedTaskTag"
                 @clear-validation="clearUpdatedTaskValidation"
                 @set-deadline="setUpdatedTaskDeadline"
                 @set-parent-task="setUpdatedTaskParentTask"
                 @set-column="setUpdatedTaskColumn"
                 @add-assignee="addUpdatedTaskAssignee"
                 @remove-assignee="removeUpdatedTaskAssignee"
                 @add-watcher="addUpdatedTaskWatcher"
                 @remove-watcher="removeUpdatedTaskWatcher"
                 @save-task="updateTask"
      />
    </transition>
    <transition name="fade">
      <AppConfirmation v-if="removeConfirmation.active"
                       text="Вы действительно хотите удалить эту задачу?"
                       @confirm="removeTask"
                       @reject="closeRemoveConfirmation"
      />
    </transition>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppButton from '@/components/page/button/AppButton'
import AppButtonSmEdit from '@/components/page/button/AppButtonSmEdit'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import ThePageComments from '@/components/page/comments/ThePageComments'
import TaskModal from '@/components/task/TaskModal'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import { formatDateTime } from '@/utils/utils'
import TaskChildrenList from '@/components/task/TaskChildrenList'

export default {
  name: 'task-info',
  components: {
    TaskChildrenList,
    AppConfirmation,
    TaskModal,
    ThePageComments,
    AppButtonSmRemove,
    AppButtonSmEdit,
    AppButton,
    ThePagePreloader
  },
  data () {
    return {
      // типы нужны так как на странице есть вывод вложений вне компонента предпросмотра вложений (AppMessageAttachmentPreview)
      mimeTypes: ['image/jpeg', 'image/gif', 'image/pjpeg', 'image/png', 'image/svg+xml', 'image/tiff', 'image/vnd.microsoft.icon', 'image/vnd.wap.wbmp', 'image/webp'],
      removeConfirmation: {
        active: false
      },
      // для хранения ссылки на текущий инпут сообщения и его выделенной области (модалка редактирования)
      modalMessageInput: null,
      modalInputSelectionRange: null,
      // для хранения ссылки на текущий инпут сообщения и его выделенной области (комментырии)
      commentMessageInput: null,
      commentInputSelectionRange: null
    }
  },
  computed: {
    task () {
      return this.$store.getters.getTaskInfo
    },
    taskMessageArea () {
      return this.$store.getters.getTaskInfoMessageArea
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    updateModal () {
      return this.$store.getters.getTaskInfoUpdateModal
    },
    columnList () {
      return this.$store.getters.tasksColumnList
    },
    isLoading () {
      return this.$store.getters.getTaskInfoIsLoading
    },
    roleAccessControls () {
      return this.currentUser.id === this.task.owner_id || this.$store.getters.getRoleRightsTasks.actionAccess
    },
    roleAccessUpdate () {
      return this.$store.getters.getRoleRightsTasks.actions.update
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightsTasks.actions.remove
    },
    userAccessRights () {
      return this.$store.getters.getRoleRightsTasks
    }
  },
  methods: {
    showRemoveConfirmation () {
      this.removeConfirmation.active = true
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
    },
    removeTask () {
      const userId = this.currentUser.id

      this.$store.dispatch('removeTask', this.task.id)
      this.removeConfirmation.active = false
      this.$router.push({ path: `/task/list/${userId}` })
    },
    startTask () {
      /* отправляем задачу сразу в колонку "В работе" (id 2)
      первые три id колонок будут всегда фиксированными, без возможности редачить пользователем */
      this.$store.dispatch('setTaskInfoStageColumn', 2)
    },
    closeTask () {
      /* отправляем задачу сразу в колонку "Завершена" (id 3) */
      this.$store.dispatch('setTaskInfoStageColumn', 3)
    },
    /* этот метод в отличии от модалки редактирования, отправляет запрос сразу по клику */
    setTaskColumn (columnId) {
      this.$store.dispatch('setTaskInfoStageColumn', columnId)
    },
    formatDateTime (date) {
      return formatDateTime(date)
    },

    // update modal
    showUpdateModal () {
      this.$store.dispatch('showTaskInfoModal')
    },
    closeUpdateModal () {
      this.$store.dispatch('closeTaskInfoModal')

      if (this.$route.query.update === 'true') {
        this.$router.replace({
          ...this.$router.currentRoute,
          query: {
            update: 'false'
          }
        })
      }
    },
    setUpdatedTaskName (text) {
      this.$store.dispatch('setTaskInfoModalName', text)
    },
    toggleUpdatedTaskImportance () {
      this.$store.dispatch('toggleTaskInfoModalImportance')
    },
    setUpdatedTaskDescription (text) {
      this.$store.dispatch('setTaskInfoModalDescription', text)
    },
    setUpdatedTaskDeadline (date) {
      this.$store.dispatch('setTaskInfoModalDeadLine', date)
    },
    setUpdatedTaskParentTask (task) {
      this.$store.dispatch('setTaskInfoModalParentTask', task)
    },
    setUpdatedTaskColumn (column) {
      this.$store.dispatch('setTaskInfoModalColumn', column)
    },
    addUpdatedTaskAssignee (user) {
      this.$store.dispatch('addTaskInfoModalAssignee', user)
    },
    removeUpdatedTaskAssignee (user) {
      this.$store.dispatch('removeTaskInfoModalAssignee', user)
    },
    addUpdatedTaskWatcher (user) {
      this.$store.dispatch('addTaskInfoModalWatcher', user)
    },
    removeUpdatedTaskWatcher (user) {
      this.$store.dispatch('removeTaskInfoModalWatcher', user)
    },
    toggleUpdatedTaskLinkTooltip () {
      this.$store.dispatch('taskInfoModalToggleLinkTooltip')
      const range = this.modalInputSelectionRange
      if (range) {
        this.$store.dispatch('taskInfoModalSetLinkText', range.toString())
      } else {
        this.$store.dispatch('taskInfoModalSetLinkText', '')
      }
    },
    closeUpdatedTaskLinkTooltip () {
      this.$store.dispatch('taskInfoModalCloseLinkTooltip')
    },
    setModalInputSelectionRange (data) {
      this.modalMessageInput = data.input

      // берем Range если не пустой, проверяем на наличие вложенных тегов (иначе обертывание в ссылку ломается), может быть undefined если выделено одно слово.
      if (!data.range.collapsed && (data.range.commonAncestorContainer.childElementCount === undefined || data.range.commonAncestorContainer.childElementCount === 0)) {
        this.modalInputSelectionRange = data.range
      } else {
        this.modalInputSelectionRange = null
      }
    },
    setUpdatedTaskLinkUrl (url) {
      this.$store.dispatch('taskInfoModalSetLinkUrl', url)
    },
    toggleUpdatedTaskTagTooltip () {
      this.$store.dispatch('taskInfoModalToggleTagTooltip')
    },
    closeUpdatedTaskTagTooltip () {
      this.$store.dispatch('taskInfoModalCloseTagTooltip')
    },
    setUpdatedTaskTagText (text) {
      this.$store.dispatch('taskInfoModalSetTagText', text)
    },
    attachUpdatedTaskFiles (files) {
      this.$store.dispatch('taskInfoModalAttachFiles', files)
    },
    removeUpdatedTaskFile (data) {
      this.$store.dispatch('taskInfoModalRemoveFile', data)
    },
    attachUpdatedTaskLink () {
      const range = this.modalInputSelectionRange
      const url = this.updateModal.attachment.linkTooltip.url.indexOf('https://') + 1 ? this.updateModal.attachment.linkTooltip.url : `https://${this.updateModal.attachment.linkTooltip.url}`

      if (range && this.updateModal.attachment.linkTooltip.url.length !== 0) {
        const linkTag = document.createElement('a')
        linkTag.setAttribute('target', '_blank')
        linkTag.setAttribute('title', url)
        linkTag.setAttribute('href', url)
        range.surroundContents(linkTag)
      }
      this.$store.dispatch('setTaskInfoModalDescription', this.modalMessageInput.innerHTML)
      this.$store.dispatch('taskInfoModalAttachLink')
    },
    attachUpdatedTaskTag () {
      this.$store.dispatch('taskInfoModalAttachTag')
    },
    removeUpdatedTaskTag (index) {
      this.$store.dispatch('taskInfoModalRemoveTag', index)
    },
    clearUpdatedTaskValidation () {
      this.$store.dispatch('taskInfoModalClearValidation')
    },
    updateTask () {
      this.$store.dispatch('taskInfoModalUpdateTask')
    },

    // comments
    setCommentMessageValue (text) {
      this.$store.dispatch('taskInfoCommentsSetMessageValue', text)
    },
    toggleCommentMessageControls (itemId) {
      this.$store.dispatch('toggleTaskInfoCommentsItemControls', itemId)
    },
    replyCommentMessage (data) {
      this.$store.dispatch('taskInfoCommentsReplyMessage', data)
    },
    unReplyCommentMessage () {
      this.$store.dispatch('taskInfoCommentsUnReplyMessage')
    },
    updateCommentMessage (itemId) {
      this.$store.dispatch('taskInfoCommentsUpdateMessage', itemId)
      const elem = this.$refs.page

      /* плавная прокрутка вниз до поля ввода */
      setTimeout(() => {
        elem.scrollTo({
          top: elem.scrollHeight,
          behavior: 'smooth'
        })
      }, 50)
    },
    removeCommentMessage (itemId) {
      this.$store.dispatch('taskInfoCommentsRemoveMessage', itemId)
    },
    attachCommentFiles (files) {
      this.$store.dispatch('taskInfoCommentsAttachFiles', files)
    },
    removeCommentFile (data) {
      this.$store.dispatch('taskInfoCommentsRemoveFile', data)
    },
    toggleCommentLinkTooltip () {
      this.$store.dispatch('taskInfoCommentsToggleLinkTooltip')
      const range = this.commentInputSelectionRange
      if (range) {
        this.$store.dispatch('taskInfoCommentsSetLinkText', range.toString())
      } else {
        this.$store.dispatch('taskInfoCommentsSetLinkText', '')
      }
    },
    closeCommentLinkTooltip () {
      this.$store.dispatch('taskInfoCommentsCloseLinkTooltip')
    },
    setCommentInputSelectionRange (data) {
      this.commentMessageInput = data.input

      // берем Range если не пустой, проверяем на наличие вложенных тегов (иначе обертывание в ссылку ломается), может быть undefined если выделено одно слово.
      if (!data.range.collapsed && (data.range.commonAncestorContainer.childElementCount === undefined || data.range.commonAncestorContainer.childElementCount === 0)) {
        this.commentInputSelectionRange = data.range
      } else {
        this.commentInputSelectionRange = null
      }
    },
    setCommentLinkUrl (url) {
      this.$store.dispatch('taskInfoCommentsSetLinkUrl', url)
    },
    attachCommentLink () {
      const range = this.commentInputSelectionRange
      const url = this.taskMessageArea.attachment.linkTooltip.url.indexOf('https://') + 1 ? this.taskMessageArea.attachment.linkTooltip.url : `https://${this.taskMessageArea.attachment.linkTooltip.url}`

      if (range && this.taskMessageArea.attachment.linkTooltip.url.length !== 0) {
        const linkTag = document.createElement('a')
        linkTag.setAttribute('target', '_blank')
        linkTag.setAttribute('title', url)
        linkTag.setAttribute('href', url)
        range.surroundContents(linkTag)
      }
      this.$store.dispatch('taskInfoCommentsSetMessageValue', this.commentMessageInput.innerHTML)
      this.$store.dispatch('taskInfoCommentsAttachLink')
    },
    toggleCommentTagTooltip () {
      this.$store.dispatch('taskInfoCommentsToggleTagTooltip')
    },
    closeCommentTagTooltip () {
      this.$store.dispatch('taskInfoCommentsCloseTagTooltip')
    },
    setCommentTagText (text) {
      this.$store.dispatch('taskInfoCommentsSetTagText', text)
    },
    attachCommentTag () {
      this.$store.dispatch('taskInfoCommentsAttachTag')
    },
    removeCommentTag (index) {
      this.$store.dispatch('taskInfoCommentsRemoveTag', index)
    },
    clearCommentValidation () {
      this.$store.dispatch('taskInfoCommentsClearValidation')
    },
    sendCommentMessage () {
      this.$store.dispatch('taskInfoCommentsSendMessage')
    },
    cancelCommentMessageUpdate () {
      this.$store.dispatch('taskInfoCommentsCancelUpdate')
    }
  },
  mounted () {
    const data = {
      taskId: this.$route.params.id,
      update: this.$route.query.update === 'true'
    }
    console.log('this.task', this.task)

    this.$store.dispatch('getTaskById', data)
  },
  // обновляем данные в компоненте, после смены маршрута (для случаев когда находясь в этом же компоненте меняем
  // маршрут на деталку другой задачи)
  beforeRouteUpdate (to, from, next) {
    const data = {
      taskId: to.params.id,
      update: null
    }

    this.$store.dispatch('getTaskById', data)
    next()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/vars';
@import '../../assets/css/system/mixins';

.page {
  position: relative;

  &__row {
    @media screen and (max-width: $tablet_start) {
      &.desktop-visible {
        display: none;
      }
    }
  }
}

.mobile-title-wrap {
  display: none;
  margin-bottom: 20px;

  @media screen and (max-width: $tablet_start) {
    display: block;
  }
}

.title {
  @media screen and (max-width: $tablet_start) {
    &.desktop-visible {
      display: none;
    }
  }
}

.back {
  color: $color_deactive-second;
  transition: .3s;
  cursor: pointer;
  user-select: none;

  @media screen and (max-width: $tablet_start) {
    margin-bottom: 20px;
  }

  &:hover {
    color: $color_second-light;
  }
}

.task {
  display: flex;
  flex-flow: row nowrap;
  border: 1px solid $border_color;
  box-shadow: 0 4px 4px rgba(23, 63, 125, 0.22);
  border-radius: 3px;
  margin-bottom: 26px;

  @media screen and (max-width: $tablet_start) {
    flex-direction: column;
  }

  &__content {
    padding-top: 20px;
    padding-bottom: 60px;
  }
}

.info {
  border-right: 1px solid $border_color;
  width: 372px;

  @media screen and (max-width: $tablet_start) {
    border-right: none;
    width: 100%;
  }

  &__block {
    color: $font_color_second;
    padding: 30px 20px;
    border-bottom: 1px solid $border_color;

    &:last-child {
      border-bottom: none;
    }
  }

  .data {
    font-weight: bold;
    margin-right: 12px;
  }

  .users-data {
    font-weight: bold;
    width: 140px;
    margin-bottom: 10px;
  }

  .row-wrap {
    display: flex;
    flex-flow: row wrap;
  }

  .value {}

  .user-item {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    cursor: pointer;
    color: $color_second-light;
    transition: .3s;
    margin-bottom: 10px;

    &__name {
      margin-left: 12px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      color: $color-second;
    }
  }
}

.status {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;

  &__name {
    margin-left: 8px;
  }

  &.ready {
    color: $font_color_alt;
    background: #2278BA;
    background: linear-gradient(90deg, #6672B1 0%, #2278BA 100%);
  }
}

.stage {
  margin-bottom: 0;

  .data {
    margin-bottom: 3px;
  }

  &__progress {
    display: flex;
    flex-flow: row wrap;
  }

  &__bar-wrap {
    margin-right: 3px;
    margin-bottom: 3px;

    &:last-child {
      margin-right: 0;
    }
  }

  &__bar {
    display: block;
    width: 30px;
    height: 10px;
    background: #D0E7F7;
    border-radius: 3px;
    cursor: pointer;
    transition: .3s;

    &.blue {
      background: #2278BA;
      background: linear-gradient(90deg, #6672B1 0%, #2278BA 100%);
    }

    &.orange {
      background: #F86758;
      background: linear-gradient(95.94deg, #FAA658 -20.08%, #F86758 122.58%);
    }

    &.pink {
      background: #D75798;
      background: linear-gradient(102.64deg, #E8506F 9.26%, #D75798 100%);
    }

    &.green {
      background: #83BC70;
      background: linear-gradient(90deg, #559E97 -18.5%, #83BC70 119.25%);
    }

    &.purple {
      background: #790D7F;
      background: linear-gradient(90deg, #BC1183 -18.5%, #790D7F 119.25%);
    }

    &.violet {
      background: #143568;
      background: linear-gradient(90deg, #6E34B8 -18.5%, #143568 119.25%);
    }

    &:hover {
      opacity: .5;
    }
  }
}

.task-attachment-preview {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 20px;

  @media screen and (max-width: $tablet_start) {
    .task-attachment {
      width: 100%;
      max-width: 360px;

      &__name {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.task-attachment {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-right: 12px;
  margin-bottom: 6px;
  color: $font_color_second;
  cursor: pointer;
  transition: .3s;

  &__icon {
    color: #D0E7F7;
    margin-right: 10px;
    transition: color .3s;
    transform: translateY(-2px);
  }

  &__size {
    margin-left: 6px;
    color: $border_color;
  }

  &__tag {
    color: $font_color_third;
  }

  &:hover {
    .task-attachment__name,
    .task-attachment__extension,
    .task-attachment__icon {
      color: $font_color_third;
    }
  }
}

.button-wrap {
  display: flex;
  flex-flow: row nowrap;
  padding-top: 64px;

  @media screen and (max-width: $tablet_start) {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  @media screen and (max-width: $mobile-sm_start) {
    flex-direction: column;
  }

  .button {
    margin-right: 12px;

    &:last-child {
      margin-right: 0;
    }

    @media screen and (max-width: $mobile-sm_start) {
      display: flex;
      justify-content: center;
      margin-right: 0;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.description {
  flex: 1;
  padding: 28px 0 28px 28px;
  color: $font_color_second;

  @media screen and (max-width: $tablet_start) {
    padding: 0 20px 20px 20px;
  }

  .text {
    padding-right: 60px;
    white-space: pre-line;
  }
}

.title {
  max-width: 408px;
}

.important-label {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-left: auto;
  background: #EA423A;
  background: linear-gradient(90.74deg, #EA7A3A -8.39%, #EA423A 118.55%);
  color: $font_color_alt;
  border-radius: 1px;
  padding: 10px 20px;

  &__text {
    margin-right: 10px;
  }

  &.mobile-visible {
    display: none;
  }

  @media screen and (max-width: $tablet_start) {
    &.mobile-visible {
      display: flex;
      width: 100%;
      justify-content: center;
    }

    &.desktop-visible {
      display: none;
    }
  }
}

.task-id {
  font-weight: bold;
  color: $font_color_second;
}

.parent-task {
  &__link {
    margin-left: 8px;
  }
}

.children-tasks {
  border: 1px solid $border_color;
  box-shadow: 0 4px 4px rgba(23, 63, 125, 0.22);
  border-radius: 3px;
  padding-bottom: 20px;
  margin-bottom: 22px;

  &__title {
    padding: 20px;
    color: $font_color_alt;
    background: $color_fourth_gradient_02;
    margin-bottom: 20px;

    @media screen and (max-width: $tablet_start) {
      padding: 10px 10px 10px 20px;
    }
  }
}
</style>
